   'use strict';
{
    var app = angular.module('tf.portfolio.marginSummary', [])

        .controller('portfoliosMarginSummaryCtrl', ['$scope', '$filter', function ($scope, $filter) {

            $scope.screen = {
                display: 'viewStrategies'
            };


            $scope.collateralChartOptions = {

                barColor: function(percent) {
                    percent = Math.min(percent, 100);
                    percent /= 100;
                    return "hsl(" + Math.round(120 * (1 - percent)) + ", 70%, 45%)";
                },
                scaleColor: false,
                trackColor: '#eee',
                lineWidth: 15,
                size: 110,
                lineCap: 'square',
                animate: {
                    duration: 1500,
                    enabled: true
                }

            };

            $scope.cardFlippedCash = false;

            $scope.excessSparklineOpts = {
                type:'bar',
                barWidth:'5%',
                height:'110px',
                tooltipFormatter : function(sparkline, options, fields) {
                    return '<div class="jqsfield">' + $filter('date')($scope.historicalExcessDates[fields[0].offset], 'EEE dd/MM HH:mm') + ' : $ ' + $filter('number')(fields[0].value, 0) + '</div>';
                }

            };

            $scope.marginSparklineOpts = {
                type:'line',
                width : '239px',
                height:'110px',
                fillColor : false,
                minSpotColor: "#A90329",
                maxSpotColor: "green",
                lineColor : 'grey',
                lineWidth : 2,
                spotRadius : 2.5,
                spotColor: '#7f7f7f',
                highlightSpotColor: '#333333',
                highlightLineColor: '#333333',
                tooltipFormatter : function(sparkline, options, fields) {
                    return '<div class="jqsfield">' + $filter('date')($scope.historicalMarginDates[fields.x], 'EEE dd/MM HH:mm') + ' : $ ' + $filter('number')(fields.y, 0) + '</div>';
                }

            };

            $scope.autoplaySlick = true;

            $scope.customStressPrevArrow = "<h1>Hello</h1>";

            $scope.responsiveOptions = [
                {
                    breakpoint: 1700,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 1220,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
                ];
        }])
;
}
